var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueryStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "query_stats"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.88 18.0345C20.32 17.3345 20.58 16.5245 20.58 15.6445C20.58 13.1545 18.57 11.1445 16.08 11.1445C13.59 11.1445 11.58 13.1545 11.58 15.6445C11.58 18.1345 13.59 20.1445 16.07 20.1445C16.95 20.1445 17.77 19.8845 18.46 19.4445L21.58 22.5645L23 21.1445L19.88 18.0345ZM16.08 18.1445C14.7 18.1445 13.58 17.0245 13.58 15.6445C13.58 14.2645 14.7 13.1445 16.08 13.1445C17.46 13.1445 18.58 14.2645 18.58 15.6445C18.58 17.0245 17.46 18.1445 16.08 18.1445ZM15.72 9.64445C14.98 9.66445 14.27 9.82445 13.62 10.0945L13.07 9.26445L9.27 15.4445L6.26 11.9245L2.63 17.7345L1 16.5645L6 8.56445L9 12.0645L13 5.56445L15.72 9.64445ZM18.31 10.1445C17.67 9.86445 16.98 9.69445 16.26 9.65445L21.38 1.56445L23 2.74445L18.31 10.1445Z",
    fill: "#F6E003"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryStats);
export default __webpack_public_path__ + "static/media/query_stats.15778b583d7187991b4093b22301af64.svg";
export { ForwardRef as ReactComponent };